/**
 * NOTE: this is a mock decorator for ast-parser.
 *
 */
export function serverOnly(): any {
  return function () {};
}
